import { FormControl, FormGroup, Validators } from '@angular/forms';

export function createKaufpreisCalculatorForm(): FormGroup<KaufpreisCalculatorFormModel> {
  return new FormGroup<KaufpreisCalculatorFormModel>({
    initialPrice: new FormControl<null | number>(null, [
      Validators.required,
      Validators.min(0),
      Validators.max(120_000)
    ])
  });
}

export interface KaufpreisCalculatorFormModel {
  initialPrice: FormControl<null | number>;
}
